import { useMutation } from '@tanstack/react-query';
import { authService } from 'shared/src/api';

export const usePostRecoverEmail = () => {
  return useMutation({
    mutationFn: authService.postRecoverEmail,
    throwOnError: false,
  });
};
